module.exports = __webpack_public_path__ + "img/black-arrow-down.baa64e61.svg";